import store from "../store";
import axios from "axios";
import resources from "./resources";
import auth from "./auth";
import dashboard from "./dashboard";
import clients from "./clients";
import addresses from "./addresses";
import pets from "./pets";
import diets from "./diets";
import quoteRequests from "./quoteRequests";
import quotes from "./quotes";
import franchises from "./franchises";
import branches from "./branches";
import ranges from "./ranges";
import orders from "./orders";
import inventories from "./inventories";
import inventoryHistories from "./inventoryHistories";
import mealSets from "./mealSets";
import orderRequests from "./orderRequests";
import users from "./users";
import roles from "./roles";
import notifications from "./notifications";
import checkout from "./checkout";
import paymentMethods from "./paymentMethods";
import productOrders from "./productOrders";
import incomes from "./incomes";
import expenses from "./expenses";
import reports from "./reports";
import productionSchedule from "./productionSchedule";

import { apiUrl } from "../runtimeConfig";

const apiClient = axios.create({
  baseURL: `${apiUrl}`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(response => {
  return response;
}, (error) => {
  if (error.response.status === 401) {
    store.dispatch("logout");
  }

  return Promise.reject(error);
});

resources.setClient(apiClient);
auth.setClient(apiClient);
dashboard.setClient(apiClient);
clients.setClient(apiClient);
addresses.setClient(apiClient);
pets.setClient(apiClient);
diets.setClient(apiClient);
quoteRequests.setClient(apiClient);
quotes.setClient(apiClient);
franchises.setClient(apiClient);
branches.setClient(apiClient);
ranges.setClient(apiClient);
orders.setClient(apiClient);
inventories.setClient(apiClient);
inventoryHistories.setClient(apiClient);
mealSets.setClient(apiClient);
orderRequests.setClient(apiClient);
users.setClient(apiClient);
roles.setClient(apiClient);
notifications.setClient(apiClient);
checkout.setClient(apiClient);
paymentMethods.setClient(apiClient);
productOrders.setClient(apiClient);
incomes.setClient(apiClient);
expenses.setClient(apiClient);
reports.setClient(apiClient);
productionSchedule.setClient(apiClient);

export default {
  resources,
  auth,
  dashboard,
  clients,
  addresses,
  pets,
  diets,
  quoteRequests,
  quotes,
  franchises,
  branches,
  ranges,
  orders,
  inventories,
  inventoryHistories,
  mealSets,
  orderRequests,
  users,
  roles,
  notifications,
  checkout,
  paymentMethods,
  productOrders,
  incomes,
  expenses,
  reports,
  productionSchedule
};
